<script lang="ts">
  import { servers } from '$lib/store'

  interface Props {
    href?: string
    title?: string
    text?: string
    lazy?: boolean
    fadeIn?: boolean
  }

  const { href = '', title = undefined, text = '', lazy = true, fadeIn = true }: Props = $props()

  /** Backend embeds https://nuread-server.{uid}/… so page text is URL-stable. */
  const NUREAD_SERVER_HOST_RE = /^nuread-server\.(.+)$/i

  function resolveNovelContentHref(raw: string): string {
    if (!raw) return raw
    try {
      const u = new URL(raw)
      const match = NUREAD_SERVER_HOST_RE.exec(u.host)
      if (!match) return raw
      const uid = match[1]
      const base = ($servers as Record<string, { urls?: string[] }>)[uid]?.urls?.[0]
      if (!base) return raw
      const origin = new URL(base)
      u.protocol = origin.protocol
      u.host = origin.host
      return u.toString()
    } catch {
      return raw
    }
  }

  let imgSrc = $derived(resolveNovelContentHref(href))
</script>

<img
  draggable="false"
  oncontextmenu={() => {
    return false
  }}
  class="mx-auto"
  src={imgSrc}
  alt={text}
/>
